export const AUTH_STORAGE_KEY = 'triiboAuthData';
export const AUTH_FLOW_LOCAL_KEY = 'triiboAuthFlow';

export function getStoredAuthData() {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearAuthFlowLocalContext() {
  localStorage.removeItem(AUTH_FLOW_LOCAL_KEY);
}

export function saveAuthData(authData) {
  if (!authData) {
    localStorage.removeItem(AUTH_STORAGE_KEY);
    return null;
  }

  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authData));
  return authData;
}

export function clearStoredAuthData() {
  localStorage.removeItem(AUTH_STORAGE_KEY);
}

export function hasCompleteAuthSession() {
  const authData = getStoredAuthData();

  return Boolean(authData?.accessToken && authData?.sessionId && authData?.userUId);
}
